import { render, staticRenderFns } from "./select_item.vue?vue&type=template&id=518bd053&scoped=true&"
import script from "./select_item.vue?vue&type=script&lang=js&"
export * from "./select_item.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "518bd053",
  null
  
)

/* hot reload */
if (module.hot) {
  var api = require("/app/node_modules/vue-hot-reload-api/dist/index.js")
  api.install(require('vue'))
  if (api.compatible) {
    module.hot.accept()
    if (!api.isRecorded('518bd053')) {
      api.createRecord('518bd053', component.options)
    } else {
      api.reload('518bd053', component.options)
    }
    module.hot.accept("./select_item.vue?vue&type=template&id=518bd053&scoped=true&", function () {
      api.rerender('518bd053', {
        render: render,
        staticRenderFns: staticRenderFns
      })
    })
  }
}
component.options.__file = "app/javascript/components/select_item.vue"
export default component.exports